<div class="container page-container">
  <valg-dk-breadcrumbs class="mb-5"></valg-dk-breadcrumbs>
  <div class="row">
    <div class="col-12">
      <div class="col-7 pl-0">
        <h1 class="h2">
          {{ 'breadcrumb.pages.export_data' | translate }}
        </h1>
        <p>
          {{ 'export_data.description' | translate }}
        </p>
        <div class="mt-6 mb-6 col-5 ml-4">
          <a [href]="guideFilePath" color="text-only-without-padding" class="hidden__sm" valgButton>
            <mat-icon  [svgIcon]="SvgIcon.Download"></mat-icon>{{ 'export_data.download' | translate }}
          </a>
        </div>
      </div>
      <div [formGroup]="form!" class="mt-5">
        <div class="row">
          <div class="col-lg-4">
            <valg-input-group>
              <label valgLabel [required]="true">{{ 'export_data.dropdown.election_type' | translate }}</label>
              <valg-input-dropdown
                [options]="electionType"
                formControlName="electionType"
                [errorKey]="'export_data.field_validation'"
                [placeholder]="'export_data.dropdown.election_type_placeholder'"
              ></valg-input-dropdown>
            </valg-input-group>
          </div>
          <div class="col-lg-4" *ngIf="isElectionTypeSelected">
            <valg-input-group>
              <label valgLabel [required]="true">{{ 'export_data.dropdown.election_date' | translate }}</label>
              <valg-input-dropdown
                [options]="electionDate"
                formControlName="electionIdByDate"
                [errorKey]="'export_data.field_validation'"
                [placeholder]="'export_data.dropdown.election_date_placeholder'"
                [customSortFunction]="customElectionDateSort"
              ></valg-input-dropdown>
            </valg-input-group>
          </div>
          <div class="col-lg-4">
            <valg-input-group *ngIf="isFVEVFAElections">
              <label valgLabel [required]="true">{{ 'export_data.dropdown.select_constituency' | translate }}</label>
              <valg-input-dropdown
                [options]="constituencies"
                formControlName="constituencies"
                [errorKey]="'export_data.field_validation'"
                [placeholder]="'export_data.dropdown.select_constituency_placeholder'"
              ></valg-input-dropdown>
            </valg-input-group>
            <valg-input-group *ngIf="isRVElection">
              <label valgLabel [required]="true">{{ 'export_data.dropdown.select_region' | translate }}</label>
              <valg-input-dropdown
                [options]="regions"
                formControlName="regions"
                [errorKey]="'export_data.field_validation'"
                [placeholder]="'export_data.dropdown.select_region_placeholder'"
              ></valg-input-dropdown>
            </valg-input-group>
            <valg-input-group *ngIf="isKVElection">
              <label valgLabel [required]="true">{{ 'export_data.dropdown.select_municipality' | translate }}</label>
              <valg-combo-box
                [options]="municipalitiesFromElection"
                formControlName="municipalitiesFromElection"
                [errorKey]="'export_data.field_validation'"
                [placeholder]="'export_data.dropdown.select_municipality_placeholder'"
              ></valg-combo-box>
            </valg-input-group>
          </div>
        </div>
        <h2 *ngIf="isOptionalNominationDistrictFVEVFAElection || isOptionalMunicipalityRVElection || isMunicipalityKVElection" class="card-heading mb-5">{{ 'export_data.optional_title' | translate }}</h2>
        <div class="row">
          <div class="col-lg-4" *ngIf="isOptionalNominationDistrictFVEVFAElection || isOptionalMunicipalityRVElection">
            <valg-input-group *ngIf="isOptionalNominationDistrictFVEVFAElection">
              <label valgLabel>{{ 'export_data.dropdown.select_nomination_district' | translate }}</label>
              <valg-input-dropdown
                [options]="nominationDistrictsFromConstituency"
                formControlName="nominationDistrictsFromConstituency"
                [placeholder]="'export_data.dropdown.select_nomination_district_placeholder'"
              ></valg-input-dropdown>
            </valg-input-group>
            <valg-input-group *ngIf="isOptionalMunicipalityRVElection">
              <label valgLabel>{{ 'export_data.dropdown.select_municipality' | translate }}</label>
              <valg-combo-box
                [options]="municipalitiesFromRegion"
                formControlName="municipalitiesFromRegion"
                [placeholder]="'export_data.dropdown.select_municipality_placeholder'"
              ></valg-combo-box>
            </valg-input-group>
          </div>
          <div class="col-lg-4">
            <valg-input-group *ngIf="isOptionalElectionAreas">
              <label valgLabel>{{ 'export_data.dropdown.select_election_area' | translate }}</label>
              <valg-input-dropdown
                [options]="electionAreas"
                formControlName="electionAreas"
                [placeholder]="'export_data.dropdown.select_election_area_placeholder'"
              ></valg-input-dropdown>
            </valg-input-group>
          </div>
        </div>
        <div class="mt-4" *ngIf="isExportButtonEnabled()">
          <button color="primary" valgButton (click)="onDownloadReportClick()">
            <mat-icon [svgIcon]="SvgIcon.Download"></mat-icon>
            {{ 'export_data.button_title' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
